import { PriorityLevel } from '@act/shared/data-transfer-objects';
import { FlexContainer } from '../../ContentContainers/FlexContainer';
import {
  TaggableChip,
  ChipColor,
} from '../../../display/TaggableChip/TaggableChip';
import { Typography } from '@mui/material';

interface ContactSoonPhaseAndPriorityProps {
  outreachPhase: string;
  priorityLevel: PriorityLevel;
}

const PriorityLevelLabelMap = {
  low: '10-15 days',
  medium: '4-9 days',
  high: '≤ 3 days',
};

const PriorityLevelColorMap: Record<PriorityLevel, ChipColor> = {
  low: 'success',
  medium: 'warning',
  high: 'error',
};

function getPhaseLabel(phase: string): string {
  if (phase?.length > 1) {
    return phase;
  } else if (phase?.length === 1) {
    return 'Phase ' + phase;
  }
  return '';
}

export const ContactSoonPhaseAndPriority = ({
  outreachPhase,
  priorityLevel,
}: ContactSoonPhaseAndPriorityProps) => {
  return (
    <FlexContainer
      direction="row"
      gap={1.5}
      height="fit-content"
      alignItems="center"
    >
      <Typography variant="bodySmall">
        {getPhaseLabel(outreachPhase)}
      </Typography>
      <TaggableChip
        label={PriorityLevelLabelMap[priorityLevel]}
        color={PriorityLevelColorMap[priorityLevel]}
        isTag
      />
    </FlexContainer>
  );
};
